import { US } from '../../../../../constants/country-codes';

const buildUSStateMapping = (states = []) => {
  const usStates = states.filter((state) => state.countryCode === US);
  return usStates.reduce((mapping, state) => {
    return {
      ...mapping,
      [state.name]: state.code,
    };
  }, {});
};

export const buildSystemPrompt = (tags = [], automationRuleData = {}) => {
  // Destructure with default empty arrays to avoid conditional checks
  const {
    carriers = [],
    carrierServices = [],
    fulfillmentProviders = [],
    marketplaces = [],
    packageTypes = [],
    packingSlips = [],
    serviceCollections = [],
    shipFroms = [],
    shippingAccounts = [],
    states = [],
    stores = [],
    taxIdentifiers = [],
    users = [],
    warehouses = [],
  } = automationRuleData;

  const tagsList =
    tags.length > 0
      ? `\n\nAvailable Tags: ${JSON.stringify(tags.map((tag) => ({ name: tag.name, id: tag.tagId })))}`
      : '\n\nNo tags available.';

  const entitiesData = {};

  if (packageTypes.length) {
    entitiesData.packageTypes = packageTypes.map((e) => ({ name: e.name, id: e.packageTypeId }));
  }
  if (shipFroms.length) {
    entitiesData.shipFroms = shipFroms.map((e) => ({ name: e.name, id: e.shipFromId }));
  }
  if (stores.length) {
    entitiesData.stores = stores.map((e) => ({ name: e.name, id: e.storeGuid }));
  }
  if (users.length) {
    entitiesData.users = users.map((e) => ({ name: e.name, id: e.userId }));
  }
  if (fulfillmentProviders.length) {
    entitiesData.fulfillmentProviders = fulfillmentProviders.map((e) => ({ name: e.name, id: e.providerId }));
  }
  if (shippingAccounts.length) {
    entitiesData.shippingAccounts = shippingAccounts.map((account) => {
      const accountServices = carrierServices.filter((service) => service.labelProviderId === account.labelProviderId);
      const carrier = carriers.find((c) => c.carrierId === accountServices[0]?.carrierId);

      return {
        name: account.name,
        id: account.labelProviderId,
        carrierId: carrier?.carrierId,
        carrierName: carrier?.name,
        carrierServices: accountServices.map((service) => ({
          name: service.name,
          id: service.serviceId,
        })),
        isWalletCarrier: !!account.walletId,
      };
    });
  }
  if (warehouses.length) {
    entitiesData.warehouses = warehouses.map((e) => ({ name: e.name, id: e.inventoryWarehouseId }));
  }
  if (taxIdentifiers.length) {
    entitiesData.taxIdentifiers = taxIdentifiers.map((e) => ({ name: e.name, id: e.taxIdentifierId }));
  }
  if (packingSlips.length) {
    entitiesData.packingSlips = packingSlips.map((e) => ({ name: e.name, id: e.packingSlipId }));
  }
  if (serviceCollections.length) {
    entitiesData.serviceCollections = serviceCollections.map((e) => ({ name: e.name, id: e.serviceCollectionGuid }));
  }
  if (carriers.length) {
    entitiesData.carriers = carriers.map((e) => ({ name: e.name, id: e.carrierId }));
  }
  if (carrierServices.length) {
    entitiesData.carrierServices = carrierServices.map((e) => ({ name: e.name, id: e.serviceId }));
  }

  // Special handling for marketplaces with additional metadata
  if (marketplaces.length) {
    entitiesData.marketplaces = marketplaces.map((e) => {
      const marketplace = { name: e.name, id: e.marketplaceId };
      if (e.apiCode) marketplace.apiCode = e.apiCode;
      if (e.searchTerms?.length) marketplace.searchTerms = e.searchTerms;
      return marketplace;
    });
  }

  const entitiesInstructions = Object.keys(entitiesData).length > 0 ? `\n\nAvailable Entities: ${JSON.stringify(entitiesData)}` : '';

  return `
  Only use valid field types, operators, and action types from the ShipStation automation rules system.${tagsList}${entitiesInstructions}
  ## CRITICAL: US STATE FILTERING MAPPINGS:  When users mention US states by name, you MUST convert them to the correct 2-letter US state codes using the available state data:
  ${
    states.length > 0
      ? `**US State Name → State Code Mappings:**
  ${Object.entries(buildUSStateMapping(states))
    .map(([name, code]) => `- "${name}" → "${code}"`)
    .join('\n')}`
      : '**No state data available - use standard US state codes**'
  }
  `;
};
